import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { useTimer } from 'Hooks/useTimer';
import { TimeText } from './QuestionnaireTimer.styled';
import { TimerContainer } from './QuestionnaireTimer.styled';

interface Props {
  duration: number;
  onTimeUp?: () => void;
}

const QuestionnaireTimer = ({ duration, onTimeUp }: Props) => {
  const { formattedTime, isWarning } = useTimer({
    initialMinutes: duration,
    onTimeUp,
  });

  if (!duration) return null;

  return (
    <TimerContainer elevation={3}>
      <AccessTimeIcon color={isWarning ? 'error' : 'action'} />
      <TimeText isWarning={isWarning}>{formattedTime}</TimeText>
    </TimerContainer>
  );
};

export default QuestionnaireTimer;
